import { Link } from "react-router-dom";
import Card from "../../elements/Card";
import Server from "./../Server";
import { useEffect } from "react";

const CreateService = () => {
    useEffect(() => {
        const oldTile = document.title
        document.title = "Hosting - SNHCloud.com"

        return () => {
            document.title = oldTile
        }
    }, [])
    
    return (
        <div className="min-h-screen flex items-center justify-center bg-trueGray-900 py-12 px-4 sm:px-6 lg:px-8">
        <div className="m-auto text-gray-200 font-bold text-center">
            <h1 className="text-2xl">
                Select Server Type
            </h1>
            <div className="gameslist gap-3">
                <Link to={`/hosting/game-server`}>
                    <Card name="Game Servers" banner="game" extra={-2}/>
                </Link>
                <Link to={`/hosting/website/directadmin/luxembourg-eu`}>
                    <Card name="Direct Admin - Website hosting" banner="directadmin" extra={-2}/>
                </Link>
                <Link to={`/hosting/discord-bot`}>
                    <Card name="Discord Bots" banner="discord" extra={-2}/>
                </Link>
                <Link to={`/hosting/voice-server`}>
                    <Card name="Voice Servers" banner="voice" extra={-2}/>
                </Link>
                <Link to={`/hosting/free-game-servers`}>
                    <Card name="FREE Game Servers" banner="freegame" extra={-2}/>
                </Link>
            </div>
            <p>Other Servers include Discord Bots, like Discord.js Discord.py Discord.go which can also run generic Applications of that lanugage</p>
        </div>
        </div>    
    ) 
}

export default CreateService;